export default {

    /**
     * Get instances list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getList: state => (id) => {
        // Return tasks list
        return Object.values(state.instances).filter((f) => f.parent_id == id);
    }
}
